import 'bootstrap-3-typeahead';

$(document).ready(function () {
		            
	var path = baseUrl + "/autocomplete";
		
	$( "body" ).on( "click", ".a-la-une",function( event ) {	
		event.preventDefault();	
		location.href= $(this).attr("data-url");
	});
	
	$( "body" ).on( "click", ".search a",function( event ) {	
		event.preventDefault();	
		$("#frmSearch").submit();
	});
	
	$('input.typeahead').typeahead({
		source: function (query, process) {
			$.ajax({
				url: path,
				type: "POST",
				data: 'q='+query,
				dataType: 'JSON',
				async: true,
				success: function(data){
				   var resultList = data.map(function (item) {
					   var link = { href: baseUrl + '/'+ item.href, name: item.name };
						   return JSON.stringify(link);					  
						 });
						return process(resultList);
				}
			})
		},	
				
		highlighter: function (link) {		
			var item = JSON.parse(link);		
			var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
			return item.name.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
				return '<strong>' + match + '</strong>'
			})
		},
		updater: function (link) {
		   var item = JSON.parse(link);       
		   location.href=item.href;       
		}
	});	
	
			
});

